import { BaseOverlayComponent } from './base-overlay/base-overlay.component';
import { SsrOverlayComponent } from './ssr-overlay/ssr-overlay.component';

export function isSsrOverlay(overlay: SsrOverlayComponent | BaseOverlayComponent): overlay is SsrOverlayComponent{
  return (overlay as SsrOverlayComponent).overlayDisposeLock !== undefined;
}